import { render, staticRenderFns } from "./AuthorizationTable.vue?vue&type=template&id=298b5fac&scoped=true&"
import script from "./AuthorizationTable.vue?vue&type=script&lang=js&"
export * from "./AuthorizationTable.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationTable.vue?vue&type=style&index=0&id=298b5fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b5fac",
  null
  
)

export default component.exports